import React, { useState, useEffect, useCallback } from "react";
import { downloadRequests } from "../api/request/request-api";

export const handleMyRequest = 
    (
        userId, 
        pageNumber, 
        requestArray, 
        setRequestArray, 
        requestIncrementSize, 
        isNoRequest,
        setIsNoRequest,
        setIsLoadingMyRequests,
        setIsShowMoreRequest, 
        setErrorContent, 
        setIsSystemError, 
        setPageNumber, 
        requestArrayLength, 
        setIsRefreshRequest, 
        isRefreshRequest, 
        userAccountType, 
        userServiceCategory
    ) => {
        
    const getMyRequests = useCallback(async () => {
        return new Promise(async(resolve, reject) => {
            try {                
                let response = await downloadRequests("Pending", pageNumber, requestIncrementSize);
                setIsLoadingMyRequests(false);
                if (requestArray.length === 0 || pageNumber === 0) {
                    if(response.length > 0){
                        setIsNoRequest(false);
                        setRequestArray(response);
                        if (response.length < requestIncrementSize) {
                            setIsShowMoreRequest(false);
                        }
                    } else {
                        setRequestArray([]);
                        setIsNoRequest(true);
                    }
                } else {
                    let newItemCount = response.length;
                    setRequestArray(requestArray => [...requestArray, ...response]);
                    if (newItemCount < requestIncrementSize) {
                        setIsShowMoreRequest(false);
                    }
                }
                resolve("success")
            } catch (error) {
                console.log(error);
                setErrorContent({ 'header': "Error getting your requests", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" });
                setIsSystemError(true);
                setIsLoadingMyRequests(false);
                reject("failed")
            }
        })
    }, [userId, pageNumber])

    //refresh My requests
    const refreshRequest = () => {
        return new Promise((resolve, reject) => {
            setIsShowMoreRequest(true);
            setPageNumber(0);
            // setRequestArray([]);
            requestArrayLength.current = 0;
            setIsRefreshRequest(true);
            resolve("success");
        });
    }

    useEffect(() => {
        if (!isRefreshRequest)
            return;
        setIsRefreshRequest(false);
        if (userAccountType == "General") {
            getMyRequests();
        }
    }, [isRefreshRequest]);    
    
    return { refreshRequest, getMyRequests };
}